<template>
  <div class="content">
    <v-card outlined :style="{ height: '196px', 'margin-bottom': '4px' }">
      <v-card-title :style="{ height: '30px' }">
        {{ $t('menu.realtime.overview.whole') }}
      </v-card-title>
      <v-row class="ma-0 pa-0" :style="{ height: '162px' }">
        <v-col cols="4" class="ma-0 pa-0 border-wrap">
          <v-card height="162px">
            <v-card-title :style="{ height: '30px', padding: '3px 8px 3px 12px' }">
              {{ userType.title }}
              <v-spacer></v-spacer>
              <div class="mr-auto d-flex">
                <v-btn-toggle dense group>
                  <v-tooltip content-class="tooltip" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="apply('UT')" v-bind="attrs" v-on="on" x-small :disabled="!userType.applyable">
                        <v-icon small color="primary">mdi-content-save</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('prefer.cc.apply') }}</span>
                  </v-tooltip>
                  <v-tooltip content-class="tooltip" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="reset('UT')" v-bind="attrs" v-on="on" x-small>
                        <v-icon small color="primary">mdi-redo-variant</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('prefer.cc.apply.default') }}</span>
                  </v-tooltip>
                </v-btn-toggle>
              </div>
            </v-card-title>
            <v-card-text class="ma-0 pa-0" :style="{ height: '132px' }">
              <v-row :style="{ height: '132px' }" class="ml-6 mr-6">
                <v-col cols="6">
                  <v-row :style="{ height: '90px', padding: '16px 0px' }">
                    <user-type-asis ref="userType" :values="userType.values" :colors="userType.colors" area-style="linearGradient" />
                  </v-row>
                  <v-row :style="{ height: '30px', 'justify-content': 'center', 'padding-top': '4px' }">
                    AS-IS
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row :style="{ height: '90px', padding: '16px 0px' }">
                    <user-type-tobe ref="userTypeTobe" :values="userType.values" :colors="userType.colorsTobe" area-style="linearGradient" :click="onClickUserType" />
                  </v-row>
                  <v-row :style="{ height: '30px', 'justify-content': 'center', 'padding-top': '4px' }">
                    TO-BE
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4" class="ma-0 pa-0 border-wrap">
          <v-card height="162px">
            <v-card-title :style="{ height: '30px', padding: '3px 8px 3px 12px' }">
              {{ wpStatus.title }}
              <v-spacer></v-spacer>
              <div class="mr-auto d-flex">
                <v-btn-toggle dense group>
                  <v-tooltip content-class="tooltip" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="apply('WS')" v-bind="attrs" v-on="on" x-small :disabled="!wpStatus.applyable">
                        <v-icon small color="primary">mdi-content-save</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('prefer.cc.apply') }}</span>
                  </v-tooltip>
                  <v-tooltip content-class="tooltip" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="reset('WS')" v-bind="attrs" v-on="on" x-small>
                        <v-icon small color="primary">mdi-redo-variant</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('prefer.cc.apply.default') }}</span>
                  </v-tooltip>
                </v-btn-toggle>
              </div>
            </v-card-title>
            <v-card-text class="ma-0 pa-0" :style="{ height: '132px' }">
              <v-row :style="{ height: '132px' }" class="ml-6 mr-6">
                <v-col cols="6">
                  <v-row :style="{ height: '90px', padding: '16px 0px' }">
                    <wp-status-asis ref="wpStatus" :values="wpStatus.values" :colors="wpStatus.colors" area-style="linearGradient" />
                  </v-row>
                  <v-row :style="{ height: '30px', 'justify-content': 'center', 'padding-top': '4px' }">
                    AS-IS
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row :style="{ height: '90px', padding: '16px 0px' }">
                    <wp-status-tobe ref="wpStatusTobe" :values="wpStatus.values" :colors="wpStatus.colorsTobe" area-style="linearGradient" :click="onClickWpStatus" />
                  </v-row>
                  <v-row :style="{ height: '30px', 'justify-content': 'center', 'padding-top': '4px' }">
                    TO-BE
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="4" class="ma-0 pa-0 border-wrap">
          <v-card height="162px">
            <v-card-title :style="{ height: '30px', padding: '3px 8px 3px 12px' }">
              {{ wpType.title }}
              <v-spacer></v-spacer>
              <div class="mr-auto d-flex">
                <v-btn-toggle dense group>
                  <v-tooltip content-class="tooltip" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="apply('WT')" v-bind="attrs" v-on="on" x-small :disabled="!wpType.applyable">
                        <v-icon small color="primary">mdi-content-save</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('prefer.cc.apply') }}</span>
                  </v-tooltip>
                  <v-tooltip content-class="tooltip" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="reset('WT')" v-bind="attrs" v-on="on" x-small>
                        <v-icon small color="primary">mdi-redo-variant</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('prefer.cc.apply.default') }}</span>
                  </v-tooltip>
                </v-btn-toggle>
              </div>
            </v-card-title>
            <v-card-text class="ma-0 pa-0" :style="{ height: '132px' }">
              <v-row :style="{ height: '132px' }" class="ml-6 mr-6">
                <v-col cols="6">
                  <v-row :style="{ height: '90px', padding: '16px 0px' }">
                    <wp-type-asis ref="wpType" :values="wpType.values" :colors="wpType.colors" area-style="linearGradient" />
                  </v-row>
                  <v-row :style="{ height: '30px', 'justify-content': 'center', 'padding-top': '4px' }">
                    AS-IS
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row :style="{ height: '90px', padding: '16px 0px' }">
                    <wp-type-tobe ref="wpTypeTobe" :values="wpType.values" :colors="wpType.colorsTobe" area-style="linearGradient" :click="onClickWpType" />
                  </v-row>
                  <v-row :style="{ height: '30px', 'justify-content': 'center', 'padding-top': '4px' }">
                    TO-BE
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <v-card outlined height="258px">
      <v-card-title :style="{ height: '30px' }">
        {{ $t('menu.realtime.overview.system') }}
      </v-card-title>
      <v-row class="ma-0 pa-0" :style="{ height: '224px' }">
        <v-col cols="8" class="ma-0 pa-0 border-wrap">
          <v-card height="224px">
            <v-card-title :style="{ height: '30px', 'justify-content': 'center' }">
              Equalizer/OWLView
              <v-spacer></v-spacer>
              <div class="mr-auto d-flex">
                <v-btn-toggle dense group>
                  <v-tooltip content-class="tooltip" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="apply('EQ')" v-bind="attrs" v-on="on" x-small :disabled="!eqOwl.applyable">
                        <v-icon small color="primary">mdi-content-save</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('prefer.cc.apply') }}</span>
                  </v-tooltip>
                  <v-tooltip content-class="tooltip" top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn @click="reset('EQ')" v-bind="attrs" v-on="on" x-small>
                        <v-icon small color="primary">mdi-redo-variant</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('prefer.cc.apply.default') }}</span>
                  </v-tooltip>
                </v-btn-toggle>
              </div>
            </v-card-title>
            <v-card-text class="ma-0 pa-0" :style="{ height: '194px' }" id="equalizer-setting">
              <v-row :style="{ height: '194px' }" class="ml-6 mr-6">
                <v-col cols="3">
                  <v-row :style="{ height: '152px', padding: '16px 0px' }">
                    <!-- eslint-disable-next-line prettier/prettier -->
                    <v-text-field v-for="(rspnSctn, idx) in rspnSection.slice().reverse()" :key="idx"
                      dense solo hide-details readonly
                      :label="`${$t('prefer.cc.section')} ${Math.abs(idx - (rspnSection.length - 1)) + 1}.`"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="3">
                  <v-row :style="{ height: '152px', padding: '16px 0px' }">
                    <!-- eslint-disable-next-line prettier/prettier -->
                    <v-text-field v-for="(rspnSctn, idx) in rspnSection.slice().reverse()" :key="idx"
                      dense solo readonly hide-details
                      :prefix="rspnSctn.prefix" suffix="ms"
                      :value="rspnSctn.rspn | comma" :background-color="rspnSctn.color"
                    ></v-text-field>
                  </v-row>
                  <v-row :style="{ height: '30px', 'justify-content': 'center', 'padding-top': '4px' }">
                    AS-IS
                  </v-row>
                </v-col>
                <v-col cols="6">
                  <v-row :style="{ height: '152px', padding: '16px 0px' }">
                    <!--
                      원 데이터 rspnSection은 응답시간이 오름 차순이다.
                      화면에서는 Equalizer chart와 동일한 모습으로 내림차순으로 보여주기 위해
                      .slice().reverse()를 이용하였고, idx 전달 시 Math.abs(idx - (rspnSection.length - 1))를 이용하였다.
                      Comment.by.KWShin.2024.01.18.
                    -->
                    <!-- eslint-disable-next-line prettier/prettier  -->
                    <v-text-field v-for="(rspnSctn, idx) in rspnSection.slice().reverse()" :key="idx"
                      dense solo hide-details readonly :style="{ 'width': '200px' }"
                      :prefix="rspnSctn.prefix" suffix="ms"
                      :value="rspnSctn.rspnTobe | comma" :background-color="rspnSctn.colorTobe"
                    >
                      <template #prepend>
                        <v-tooltip content-class="tooltip" top>
                          <template v-slot:activator="{ on, attrs }">
                            <!-- 최상위 구간 값은 그 차상위 구간 값과 동일하기 때문에 굳이 값 변경 버튼이 필요없다. -->
                            <v-btn :disabled="idx == 0" id="minus-btn" class="icon" v-bind="attrs" v-on="on" x-small text @click="onRspnMinus(Math.abs(idx - (rspnSection.length - 1)))">
                              <v-icon>mdi-minus-circle-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('prefer.cc.minus.rspn') }}</span>
                        </v-tooltip>
                      </template>
                      <template #append-outer>
                        <v-tooltip content-class="tooltip" top>
                          <template v-slot:activator="{ on, attrs }">
                            <!-- 최상위 구간 값은 그 차상위 구간 값과 동일하기 때문에 굳이 값 변경 버튼이 필요없다. -->
                            <v-btn :disabled="idx == 0" id="plus-btn" class="icon" v-bind="attrs" v-on="on" x-small text @click="onRspnPlus(Math.abs(idx - (rspnSection.length - 1)))">
                              <v-icon>mdi-plus-circle-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('prefer.cc.plus.rspn') }}</span>
                        </v-tooltip>
                        <v-tooltip content-class="tooltip" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn class="icon" v-bind="attrs" v-on="on" x-small text @click="onShowPalette($event, Math.abs(idx - (rspnSection.length - 1)))">
                              <v-icon>mdi-palette-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('prefer.cc.select.color') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-row>
                  <v-row :style="{ height: '30px', 'justify-content': 'center', 'padding-top': '4px' }">
                    TO-BE
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
    <div v-show="cp.show" :style="colorPickerStyle()" class="border-wrap">
      <v-card id="cp-wrapper">
        <v-card-title :style="{ height: '30px', 'justify-content': 'center' }">
          {{ selectedSliceName }}
        </v-card-title>
        <!-- eslint-disable-next-line prettier/prettier -->
        <v-color-picker :value="cp.value" hide-canvas hide-mode-switch hide-sliders hide-preview
          :mode.sync="cp.mode" show-swatches swatches-max-height="250" @update:color="updateColor"
        ></v-color-picker>
      </v-card>
    </div>
  </div>
</template>

<script>
import UserTypeAsis from '@/views/overview/whole/chart/Pie.vue';
import UserTypeTobe from '@/views/overview/whole/chart/Pie.vue';
import WpStatusAsis from '@/views/overview/whole/chart/Pie.vue';
import WpStatusTobe from '@/views/overview/whole/chart/Pie.vue';
import WpTypeAsis from '@/views/overview/whole/chart/Pie.vue';
import WpTypeTobe from '@/views/overview/whole/chart/Pie.vue';
import { api } from '@/api/common/instances';
import { isEmpty } from 'lodash';

export default {
  components: {
    UserTypeAsis,
    UserTypeTobe,
    WpStatusAsis,
    WpStatusTobe,
    WpTypeAsis,
    WpTypeTobe,
  },
  data() {
    return {
      cp: {
        show: false,
        x: 0,
        y: 0,
        value: null,
        mode: 'hexa',
        caller: '',
      },
      userType: {
        key: 'UT',
        title: this.$t('prefer.cc.title.user.type'),
        motletId: 'preference/chart-color/user-type/color',
        values: [],
        colorsDefault: ['#7986CB', '#9E9E9E', '#039BE5', '#26A69A'],
        colors: [],
        colorsTobe: [],
        sdi: 0, // Selected Data Index !!
        chart: null,
        chartTobe: null,
        applyable: false,
      },
      wpStatus: {
        key: 'WS',
        title: this.$t('prefer.cc.title.wp.status'),
        motletId: 'preference/chart-color/wp-status/color',
        values: [],
        colorsDefault: ['#C23531', '#2F4554', '#61A0A8', '#D48265', '#91C7AE', '#749F83', '#CA8622'],
        colors: [],
        colorsTobe: [],
        sdi: 0, // Selected Data Index !!
        chart: null,
        chartTobe: null,
        applyable: false,
      },
      wpType: {
        key: 'WT',
        title: this.$t('prefer.cc.title.wp.type'),
        motletId: 'preference/chart-color/wp-type/color',
        values: [],
        colorsDefault: ['#C23531', '#2F4554', '#61A0A8', '#D48265', '#91C7AE', '#749F83'],
        colors: [],
        colorsTobe: [],
        sdi: 0, // Selected Data Index !!
        chart: null,
        chartTobe: null,
        applyable: false,
      },
      eqOwl: {
        key: 'EQ',
        motletIdColor: 'preference/chart-color/eq-owl/color',
        motletIdSection: 'preference/chart-color/eq-owl/rspn-section',
        sdi: 0, // Selected Data Index !!
        applyable: false,
      },
      rspnSection: [
        { color: '', colorTobe: '', colorDefault: '#87CC66', prefix: '<=', rspn: 0, rspnTobe: 0, rspnDefault: 500 },
        { color: '', colorTobe: '', colorDefault: '#7BBAE7', prefix: '<=', rspn: 0, rspnTobe: 0, rspnDefault: 1500 },
        { color: '', colorTobe: '', colorDefault: '#FFDD00', prefix: '<=', rspn: 0, rspnTobe: 0, rspnDefault: 4000 },
        { color: '', colorTobe: '', colorDefault: '#FF7800', prefix: '<=', rspn: 0, rspnTobe: 0, rspnDefault: 6000 },
        { color: '', colorTobe: '', colorDefault: '#FF0000', prefix: ' >', rspn: 0, rspnTobe: 0, rspnDefault: 6000 },
      ],
      chartDataPieAll: [],
      scd: {}, // Selected Chart Data !!
      selectedSliceName: '',
      apiUrl: '/preference/users/admin/motlet-properties',
    };
  },
  methods: {
    async apply(chartKind) {
      const confirmRslt = await this.$dialog.confirm(this.$t('prefer.cc.apply.confirm'));
      if (confirmRslt) {
        if (chartKind == 'EQ') {
          await api.put(this.apiUrl, { motletId: this.eqOwl.motletIdColor, motletProperties: this.rspnSection.map(elm => elm.colorTobe).join(',') });
          await api.put(this.apiUrl, { motletId: this.eqOwl.motletIdSection, motletProperties: this.rspnSection.map(elm => elm.rspnTobe).join(',') });
          this.rspnSection.forEach(elm => {
            elm.color = elm.colorTobe;
            elm.rspn = elm.rspnTobe;
          });
          this.eqOwl.applyable = false;
          return;
        }
        const chartData = this.chartDataPieAll.find(data => data.key == chartKind);
        await api.put(this.apiUrl, { motletId: chartData.motletId, motletProperties: chartData.colorsTobe.toString() });
        chartData.colors = chartData.colorsTobe;
        chartData.chart.setOptions();
        chartData.applyable = false;
      }
    },
    async reset(chartKind) {
      const confirmRslt = await this.$dialog.confirm(this.$t('prefer.cc.apply.default.confirm'));
      if (confirmRslt) {
        if (chartKind == 'EQ') {
          await api.put(this.apiUrl, { motletId: this.eqOwl.motletIdColor, motletProperties: this.rspnSection.map(elm => elm.colorDefault).join(',') });
          await api.put(this.apiUrl, { motletId: this.eqOwl.motletIdSection, motletProperties: this.rspnSection.map(elm => elm.rspnDefault).join(',') });
          this.rspnSection.forEach(elm => {
            elm.color = elm.colorDefault;
            elm.rspn = elm.rspnDefault;
            elm.colorTobe = elm.colorDefault;
            elm.rspnTobe = elm.rspnDefault;
          });
          return;
        }
        const chartData = this.chartDataPieAll.find(data => data.key == chartKind);
        await api.put(this.apiUrl, { motletId: chartData.motletId, motletProperties: chartData.colorsDefault.toString() });
        chartData.colors = chartData.colorsDefault;
        chartData.colorsTobe = chartData.colorsDefault;
        chartData.chart.setOptions();
      }
    },
    onClickUserType(params) {
      this.onClickPie(this.userType, params);
    },
    onClickWpStatus(params) {
      this.onClickPie(this.wpStatus, params);
    },
    onClickWpType(params) {
      this.onClickPie(this.wpType, params);
    },
    onClickPie(chartData, params) {
      this.scd = chartData;
      this.scd.sdi = params.dataIndex;
      this.selectedSliceName = `${this.scd.title} (${this.scd.values[this.scd.sdi].name})`;
      this.cp.caller = this.scd.key;
      this.cp.value = this.scd.colors[this.scd.sdi];
      this.cp.x = params.event.event.pageX;
      this.cp.y = params.event.event.pageY;
      this.cp.show = !this.cp.show;
    },
    updateColor(color) {
      if (this.cp.caller == 'EQ') {
        this.rspnSection[this.eqOwl.sdi].colorTobe = color.hex;
        this.eqOwl.applyable = true;
        this.cp.show = !this.cp.show;
        return;
      }
      if (this.scd.colorsTobe) {
        this.scd.colorsTobe[this.scd.sdi] = color.hex;
        /*
          야...이거 도대체 이유가 뭐냐...
          Pie.vue에 colors가 Props로 전달이 되는데...
          colors 값을 아무리 바꾸어도 Pie.vue 쪽에서 그 변경된 사실을 인지하지 못한다.
          이 방법 저 방법 다 써봐도 무소용이다.
          할 수 없이 Pie.vue에 메소드를 만들고 그 메소드를 직접 호출하는 방식으로 문제를 해결하였다.
          2024.01.11.KWShin.
        */
        this.scd.chartTobe.setOptions();
        this.scd.applyable = true;
        this.cp.show = !this.cp.show;
      }
    },
    colorPickerStyle() {
      return `position: fixed; top: ${this.cp.y + 10}px; left: ${this.cp.x + 10}px;`;
    },
    onRspnMinus(idx) {
      const ss = this.rspnSection[idx]; // ss = selected selection
      if (idx > 0) {
        if (ss.rspnTobe - 100 <= this.rspnSection[idx - 1].rspnTobe) {
          // 하위 구간보다 값이 적거나 같을 수 없다.
          this.$snackbar(this.$t('prefer.cc.info.than.lower'));
          return;
        }
      }
      if (ss.rspnTobe > 100) {
        ss.rspnTobe -= 100;
        this.eqOwl.applyable = true;
      } else {
        this.$snackbar(this.$t('prefer.cc.info.min.rspn'));
        return;
      }
      // 최상위 구간 값을 그 차상위 구간의 값과 동기화.
      if (idx == this.rspnSection.length - 2) this.rspnSection[this.rspnSection.length - 1].rspnTobe = ss.rspnTobe;
    },
    onRspnPlus(idx) {
      const ss = this.rspnSection[idx]; // ss = selected selection
      if (idx < this.rspnSection.length - 2) {
        if (ss.rspnTobe + 100 >= this.rspnSection[idx + 1].rspnTobe) {
          // 상위 구간보다 값이 크거나 같을 수 없다.
          this.$snackbar(this.$t('prefer.cc.info.than.upper'));
          return;
        }
      }
      if (ss.rspnTobe < 10000) {
        ss.rspnTobe += 100;
        this.eqOwl.applyable = true;
      } else {
        this.$snackbar(this.$t('prefer.cc.info.max.rspn'));
        return;
      }
      // 최상위 구간 값을 그 차상위 구간의 값과 동기화.
      if (idx == this.rspnSection.length - 2) this.rspnSection[this.rspnSection.length - 1].rspnTobe = ss.rspnTobe;
    },
    onShowPalette(event, idx) {
      const ss = this.rspnSection[idx]; // ss = selected selection
      this.selectedSliceName = `${this.$t('prefer.cc.title.equalizer')} (${ss.prefix} ${ss.rspnTobe})`;
      this.eqOwl.sdi = idx;
      this.cp.caller = 'EQ';
      this.cp.value = ss.colorTobe;
      this.cp.x = event.pageX;
      this.cp.y = event.pageY;
      this.cp.show = !this.cp.show;
    },
  },
  async created() {
    // DB에서 Pie chart 설정들을 읽어와서 데이터를 초기화 한다.
    this.chartDataPieAll = [this.userType, this.wpStatus, this.wpType];
    this.chartDataPieAll.forEach(async data => {
      let rspn = await api.get(`${this.apiUrl}?motletId=${data.motletId}`);
      if (!isEmpty(rspn.data.motletProperties)) data.colors = rspn.data.motletProperties.split(',');
      else data.colors = data.colorsDefault;
      data.colorsTobe = data.colors;
    }, this);

    // DB에서 Equalizer chart 색상 설정을 읽어와서 데이터를 초기화 한다.
    let rspn = await api.get(`${this.apiUrl}?motletId=${this.eqOwl.motletIdColor}`);
    if (!isEmpty(rspn.data.motletProperties)) {
      const preferColor = rspn.data.motletProperties.split(',');
      preferColor.forEach((elm, idx) => {
        this.rspnSection[idx].color = elm;
      });
    } else {
      this.rspnSection.forEach(elm => {
        elm.color = elm.colorDefault;
      });
    }
    this.rspnSection.forEach(elm => {
      elm.colorTobe = elm.color;
    });

    // DB에서 Equalizer chart 색상 설정을 읽어와서 데이터를 초기화 한다.
    rspn = await api.get(`${this.apiUrl}?motletId=${this.eqOwl.motletIdSection}`);
    if (!isEmpty(rspn.data.motletProperties)) {
      const preferSctn = rspn.data.motletProperties.split(',');
      preferSctn.forEach((elm, idx) => {
        this.rspnSection[idx].rspn = parseInt(elm);
      });
    } else {
      this.rspnSection.forEach(elm => {
        elm.rspn = elm.rspnDefault;
      });
    }
    this.rspnSection.forEach(elm => {
      elm.rspnTobe = elm.rspn;
    });

    // eslint-disable-next-line prettier/prettier
    this.userType.values = [
      { name: this.$t('logon.user.type.2'), value: 25 },
      { name: this.$t('logon.user.type.4'), value: 25 },
      { name: this.$t('logon.user.type.32'), value: 25 },
      { name: this.$t('logon.user.type.202'), value: 25 },
    ];
    // eslint-disable-next-line prettier/prettier
    this.wpStatus.values = [
      { name: this.$t('workprcs.status.2'), value: 16 },
      { name: this.$t('workprcs.status.4'), value: 14 },
      { name: this.$t('workprcs.status.8'), value: 14 },
      { name: this.$t('workprcs.status.16'), value: 14 },
      { name: this.$t('workprcs.status.32'), value: 14 },
      { name: this.$t('workprcs.status.64'), value: 14 },
      { name: this.$t('workprcs.status.128'), value: 14 },
    ];
    // eslint-disable-next-line prettier/prettier
    this.wpType.values = [
      { name: this.$t('workprcs.type.1'), value: 20 },
      { name: this.$t('workprcs.type.2'), value: 16 },
      { name: this.$t('workprcs.type.3'), value: 16 },
      { name: this.$t('workprcs.type.4'), value: 16 },
      { name: this.$t('workprcs.type.5'), value: 16 },
      { name: this.$t('workprcs.type.6'), value: 16 },
    ];
  },
  mounted() {
    this.userType.chart = this.$refs.userType;
    this.userType.chartTobe = this.$refs.userTypeTobe;
    this.wpStatus.chart = this.$refs.wpStatus;
    this.wpStatus.chartTobe = this.$refs.wpStatusTobe;
    this.wpType.chart = this.$refs.wpType;
    this.wpType.chartTobe = this.$refs.wpTypeTobe;
  },
};
</script>
<!-- scoped 속성을 넣으면 아래에 기입한 style이 먹질 않는다. 연유가 뭘까? 2024.01.17.KWShin. -->
<!--style scoped-->
<style>
.content {
  min-width: 800px;
  min-height: 462px;
}
/*
  v-color-picker의 Props 'hide-sliders' 설정이 먹질 않아 style로 강제로 보이지 않게 하였다.
  또한, 여백이 너무 커서 적절히 조정하였다.
  Added.by.KWShin.2024.01.03. 
*/
div#cp-wrapper div.v-color-picker__controls {
  padding: 0px 16px 0px 16px;
}
div#cp-wrapper div.v-color-picker__preview {
  display: none;
}
div#cp-wrapper div.v-color-picker__edit {
  margin-top: 16px;
}
/*
 * 'minus-btn'이라는 id를 가진 button 태그를 가진,
 * 'v-input__prepend-outer'라는 클래스를 가진 div 태그에 
 * CSS를 적용하라! 
 * 젠장... 이렇게 해서 Vuetify component의 slot이 가진
 * 디폴트 스타일을 변경했다.
 * 2024.01.17.KWShin.
*/
div.v-input__prepend-outer:has(button#minus-btn) {
  margin: 2px 0px 0px 10px;
}
div.v-input__append-outer:has(button#plus-btn) {
  margin: 2px 0px 0px 0px;
}
div#equalizer-setting div.v-input input {
  text-align: right;
}
</style>
